const DEFAULT_IMAGE_BASE_URL = 'https://indoteknisi.net';

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');
const trimLeadingSlash = (value: string) => value.replace(/^\/+/, '');

export const imageBaseUrl = trimTrailingSlash(import.meta.env.VITE_IMAGE_URL || DEFAULT_IMAGE_BASE_URL);

export const resolveDynamicImageUrl = (path?: string | null) => {
  if (!path) return '';

  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }

  return `${imageBaseUrl}/${trimLeadingSlash(path)}`;
};

export const resolveStorageImageUrl = (path?: string | null) => {
  if (!path) return '';

  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }

  const normalizedPath = trimLeadingSlash(path);

  if (normalizedPath.startsWith('storage/') || normalizedPath.startsWith('storage/app/public/')) {
    return resolveDynamicImageUrl(normalizedPath);
  }

  return resolveDynamicImageUrl(`storage/${normalizedPath}`);
};

/**
 * V3: utamakan URL absolut dari API (`evidence_media[].url`).
 * Fallback path/filename legacy (tebak booking/evidence hanya jika tanpa '/').
 */
export const resolveEvidenceMediaUrl = (
  ev?: { url?: string | null; image?: string | null; path?: string | null } | string | null,
) => {
  if (!ev) return '';

  if (typeof ev === 'string') {
    if (/^(https?:)?\/\//i.test(ev) || ev.startsWith('data:') || ev.startsWith('blob:')) {
      return ev;
    }
    if (ev.includes('/')) {
      return resolveStorageImageUrl(ev);
    }
    return resolveStorageImageUrl(`booking/evidence/${ev}`);
  }

  if (ev.url) {
    return resolveStorageImageUrl(ev.url);
  }

  const path = ev.path || ev.image || '';
  return resolveEvidenceMediaUrl(path);
};

/** V6: deteksi item bukti video dari type / mime / ekstensi path|url. */
export const isEvidenceVideo = (
  ev?: {
    type?: string | null;
    mime?: string | null;
    url?: string | null;
    image?: string | null;
    path?: string | null;
  } | string | null,
): boolean => {
  if (!ev) return false;

  if (typeof ev === 'string') {
    return /\.(mp4|mov|m4v|webm|mkv)(\?|#|$)/i.test(ev);
  }

  const type = (ev.type || '').toLowerCase();
  if (type === 'video') return true;
  if (type === 'photo' || type === 'image') return false;

  const mime = (ev.mime || '').toLowerCase();
  if (mime.startsWith('video/')) return true;

  const haystack = `${ev.url || ''} ${ev.path || ''} ${ev.image || ''}`;
  return /\.(mp4|mov|m4v|webm|mkv)(\?|#|$)/i.test(haystack);
};
